import { Link } from 'react-router-dom';

import { buildBreadcrumbJsonLd, serializeJsonLd } from '@/lib/seo';
import { classNames } from '@/utils/classNames';

import styles from '@/styles/layout.module.css';

type BreadcrumbItem = {
  label: string;
  to?: string;
};

type PageBreadcrumbProps = {
  items: BreadcrumbItem[];
  className?: string;
};

export function PageBreadcrumb({ items, className }: PageBreadcrumbProps): JSX.Element | null {
  if (items.length === 0) {
    return null;
  }

  const currentPath = typeof window !== 'undefined' ? window.location.pathname : '/';
  const breadcrumbJsonLd = buildBreadcrumbJsonLd(items, currentPath);

  return (
    <>
      {breadcrumbJsonLd ? <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: serializeJsonLd(breadcrumbJsonLd) }} /> : null}

      <nav aria-label="Breadcrumb" className={classNames(styles.breadcrumb, className)}>
        <ol className={styles.breadcrumbList}>
          {items.map((item, index) => {
            const isLast = index === items.length - 1;

            return (
              <li key={`${item.label}-${index}`} className={styles.breadcrumbItem}>
                {item.to && !isLast ? (
                  <Link className={styles.breadcrumbLink} to={item.to}>
                    {item.label}
                  </Link>
                ) : (
                  <span className={isLast ? styles.breadcrumbCurrent : styles.breadcrumbText} aria-current={isLast ? 'page' : undefined}>
                    {item.label}
                  </span>
                )}

                {!isLast ? <span className={styles.breadcrumbSeparator} aria-hidden="true">/</span> : null}
              </li>
            );
          })}
        </ol>
      </nav>
    </>
  );
}
